import React from 'react';

const RefreshIcon = () => {
  return (
        <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 1.998v6h-6M1 17.998v-6h6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.51 6.998a9 9 0 0 1 14.85-3.36L23 7.998M1 11.998l4.64 4.36a9 9 0 0 0 14.85-3.36" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default RefreshIcon;